import styled from "styled-components";

export const ClearBoth = styled.div` 
    &:after {
        clear: both;
        display: block;
        content: '';
    }
`